export default __webpack_public_path__ + "static/exercise-1584078ee99bc2563f164b6f76d0bb99.png";